import React from "react";
import axios from "axios";
import getSong from "../api/getSong";

export default function LibrarySong({
  id,
  song,
  songs,
  setSongs,
  setCurrentSong,
  currentSong,
  isPlaying,
  audioRef,
  setIsLoading
}) {
  
  const selectedSongHandler = async () => {
    const selectedSong = await getSong(song.id);
    setCurrentSong(selectedSong);
    setIsLoading(false);
    const newSongs = songs.map((song) => {
      if (song.id === id) {
        return { ...song, active: true };
      } else {
        return { ...song, active: false };
      }
    });
    await setSongs(newSongs);

    if (isPlaying) {
      audioRef.current.play();
    }
  };

  return (
    <div
      onClick={() => {
        selectedSongHandler();
      }}
      className={`flex gap-x-3 p-4 cursor-pointer rounded-xl ${song.active ? "dark:bg-[#0d0f17] bg-[#fce168]" : ""
        }`}
    >
      <div className="flex gap-x-3 transform hover:bg-none hover:transition duration-500 hover:scale-110">
        <div className="cover p-1">
          <img className="h-10 w-10 rounded-full object-cover" src={song.imageUrl} alt="cover" />
        </div>
        <div className="songDetails w-60 font-varela">
          <p className=" font-semibold text-lg truncate">{song.title}</p>
          {/* <p className=" text-xs truncate">{song.artist}</p> */}
        </div>
      </div>
    </div>
  );
}
